import React from 'react';
import ForumChildrens from "./components/ForumChildrens";
import Advertising from "../../components/Advertising/Advertising";
import TagModerationQualificationWarning
    from "../../components/TagModerationQualificationWarning/TagModerationQualificationWarning";
import {Can} from "../../../ability-context";


const ForumsSubOrTopics = (props)=>(
    <div className="forums-subcategory">
        <Can action={"qualification"} subject="TagModeration">
            <TagModerationQualificationWarning />
        </Can>
        <div className="container">
            <Advertising sizeMobile={"300x100"} className={"center"} />
            <div className={"forum-card"}>
                <div className={"card big"}>
                    <ForumChildrens location={props.location} forumId={props.match.params.id}
                                    match={props.match}/>
                </div>
            </div>
        </div>
    </div>
);

export default (ForumsSubOrTopics);
